import { BRAND } from "@/data/content";

export const Logo = ({ inverse = false, size = "md", className = "" }) => {
  const sizes = {
    sm: { inc: "text-2xl", sub: "text-[9px]" },
    md: { inc: "text-3xl", sub: "text-[10px]" },
    lg: { inc: "text-5xl", sub: "text-xs" },
    xl: { inc: "text-7xl sm:text-8xl", sub: "text-sm" },
  };
  const s = sizes[size] || sizes.md;
  const subColor = inverse ? "text-cream/80" : "text-[#6b5a4a]";

  return (
    <div
      className={`inline-flex flex-col items-center leading-none ${className}`}
      data-testid="brand-logo"
      aria-label={BRAND.name}
    >
      <div
        className={`font-display font-bold ${s.inc} text-[#c63027] tracking-[-0.02em]`}
      >
        INC.
      </div>
      <div
        className={`mt-1 font-sans-body font-semibold uppercase tracking-[0.32em] ${s.sub} ${subColor}`}
      >
        Cleaning&nbsp;Services
      </div>
    </div>
  );
};

export const LogoInline = ({ className = "", inverse = false }) => (
  <div
    className={`inline-flex items-baseline gap-2 ${className}`}
    data-testid="brand-logo-inline"
  >
    <span className="font-display font-bold text-2xl text-[#c63027] leading-none tracking-tight">
      INC.
    </span>
    <span
      className={`font-sans-body font-bold text-[10px] uppercase tracking-[0.3em] ${
        inverse ? "text-cream/90" : "text-[#6b5a4a]"
      }`}
    >
      Cleaning&nbsp;Services
    </span>
  </div>
);
